const change_theme = "change_theme";

export default {
  change_theme,
};
